import React from 'react';
import Newsletter from './Newsletter';
import styles from '../styles/Footer.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

const assetUrl = path => `${publicUrl}${path}`;

const menuLinks = [
  { label: 'Bar', path: '/Bar' },
  { label: 'Snacks', path: '/Delicious' },
  { label: 'Artisan Breads', path: '/Artisan-Breads' },
  { label: 'Hot Drinks', path: '/Coffee' },
  { label: 'Desserts', path: '/Desserts' },
];

const siteLinks = [
  { label: 'Home', path: '/' },
  { label: 'Menu', path: '/Menu' },
  { label: 'Shop', path: '/Shop' },
  { label: 'Blog', path: '/Blog' },
  { label: 'Portfolio', path: '/Portfolio' },
  { label: 'Galerie', path: '/Galerie' },
  { label: 'Testimonials', path: '/Testimonials' },
  { label: 'Contact', path: '/Contact' },
];

const Footer = () => (
  <footer
    className={styles.footer}
    style={{ backgroundImage: `url('${assetUrl('/images/rest-bg.webp')}')` }}
  >
    <div className={styles.content}>
      <div className={styles.footerGrid}>
        <div className={styles.linkColumn}>
          <img
            className={styles.footerLogo}
            src={assetUrl('/images/grain-bitess.webp')}
            alt="Grain Bites"
          />
          <p className={styles.brandTitle}>Grain Bites</p>
          <div className={styles.contactBox}>
            <span>Sofia, Bulgaria</span>
            <a href="tel:+359497681666">00359 (049) 768 1666</a>
          </div>
        </div>

        <div className={styles.mainLinkColumn}>
          <div className={styles.linkGroups}>
            <div>
              <p className={styles.sectionTitle}>Explore</p>
              <nav className={styles.mainNav} aria-label="Main navigation">
                {siteLinks.map(link => (
                  <a key={link.label} href={`${publicUrl}${link.path}`}>{link.label}</a>
                ))}
              </nav>
            </div>

            <div>
              <p className={styles.sectionTitle}>Taste selection</p>
              <nav className={styles.mainNav} aria-label="Menu navigation">
                {menuLinks.map(link => (
                  <a key={link.label} href={`${publicUrl}${link.path}`}>{link.label}</a>
                ))}
              </nav>
            </div>
          </div>
        </div>

        <Newsletter />
      </div>

      <div className={styles.footerEnd}>
        <h3>The style and the design</h3>
        <div className={styles.socialLinks}>
          <a href="#facebook" aria-label="Facebook">
            <img className={styles.socialIcon} src={assetUrl('/images/brand/face.png')} alt="" />
          </a>
          <a href="#instagram" aria-label="Instagram">
            <img className={styles.socialIcon} src={assetUrl('/images/brand/insta.png')} alt="" />
          </a>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <p className={styles.copyright}>Grain Bites © 2017 All rights reserved — Irena Popova</p>
        <nav className={styles.footerNav} aria-label="Footer navigation">
          <a href="#impressum">Impressum</a>
          <a href={`${publicUrl}/Portfolio`}>Our Story</a>
          <a href="#datenschutz">Datenschutz</a>
        </nav>
      </div>
    </div>
  </footer>
);

export default Footer;
